import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import * as ElIconModules from '@element-plus/icons-vue'
import ApiKeyGate from "@/components/ApiKeyGate.vue";

const app = createApp(ApiKeyGate)
app.use(ElementPlus)


Object.keys(ElIconModules).forEach(function (key) {
    app.component(ElIconModules[key].name, ElIconModules[key])
})

app.mount('#app')
